import React, { useState } from 'react';

import './DvrHealthReportScreenshot.scss';
import GridView from '../../../../../components/elements/GridView/index';


// {
//     "id": 101,
//     "dvr_health_report_id": 2,
//     "alarm_at": "2025-02-02 07:21:50",
//     "alarm_id": 1119802859,
//     "alert_type": 4,
//     "alert_text": "Camera Signal Lost (CH2 ) Alarm Start"
//   }

export interface DvrHealthReportScreenshotProps {
    screenshots: Array<any>;
}

const DvrHealthReportScreenshot: React.FC<DvrHealthReportScreenshotProps> = ({
    screenshots = []
}) => {
    const logList = screenshots.map((item, index) => {
        const [focused, setFocused] = useState(false);
        return (<div key={'screenshot_' + index} className={`dvr-screenshot ${focused ? 'is-focused' : ''}`} onClick={() => { setFocused(!focused) }}>
            <img src={item.screenshotUrl} />
        </div>);
    });
    const scroll = {
        x: 'max-content',
        y: 'calc(30vh)',
    }
    return (
        <div className='dvr-health-report-screenshot'>
            {logList}
        </div>
    );
}

export default DvrHealthReportScreenshot;